<template>
  <div id="hero">
    <div
      class="lg:p-3 pt-[50px] h-[530px] h-[1000px] lg:pt-atas 2xl:px-48 lg:h-[720px] flex-container bg-bgcc bg-cover bg-no-repeat bg-left-bottom">
      <div class="flex flex-wrap mx-3 lg:mx-0">
        <div class="w-full self-end px-2 lg:w-1/2">
          <div class="mt-0 lg:mt-5">
            <img src="@/assets/cctv11.png" alt="catra" class="h-[200px] lg:h-[600px] lg:max-w-full mx-auto" />
          </div>
        </div>
        <div class="w-full mt-[50px] lg:mt-[100px] text-right pl-0 lg:w-1/2">
          <h1 class="text-md lg:text-lg font-bold mt-0">
            Paket Pemasangan <span class="text-primary">CCTV</span>
            Lengkap Siap Pasang,
            Terjangkau, Original
          </h1>
          <h1 class="text-md lg:text-lg font-bold mt-0">
            dan Bergaransi Resmi
          </h1>
          <h2 class="text-sm font-light mb-[60px]">Melayani Pemasangan Seluruh Indonesia Gratis Survei &
            Konsultasi</h2>
          <a href="https://wa.me/6285136700367"
            class="transition duration-300 ease-in-out hover:bg-primary hover:text-bodas text-primary border-2 border-primary font-bold bg-bodas py-3 px-12 rounded-xl">
            Consultation
            NOW !
          </a>
        </div>
      </div>
    </div>

    <!-- <div class="bg-cover bg-center bg-no-repeat 5 bg-cats pt-0">
        <div class="grid grid-cols-2 gap-10 pt-15 h-[700px]">
          <div class="text-left p-60">
            <p class="text-4xl font-extrabold">
              SCIENTIFICS
              <a class="text-primary">RESEARCH</a>
            </p>
            <p class="text-4xl font-extrabold">
              JOURNAL
            </p>
            <a href="https://api.whatsapp.com/send/?phone=6281120011644&text&type=phone_number&app_absent=0">
            <button
              type="button"
              class="text-bodas bg-primary hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-primary dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >Consultation NOW !</button>
          </a>
          </div>
          <div class="place-content-center">
            <div class>
              <img class="h-[629px] w-[629px]" src="../assets/home1.png" alt="homie" />
            </div>
          </div>
        </div>
    </div>-->
  </div>
</template>

<script>
import "@/assets/tailwind.css";

export default {};
</script>

<style></style>